<ng-container *transloco="let convert;">
  <div class="modal__content">
    <header class="modal__header">
      <p class="modal-heading">
        <i class="allycon-error-fill text-danger pe-2" aria-hidden="true"></i>
        {{ convert('vehicles.higherExistingOffer.titleWarning') }}
      </p>
    </header>
    <p class="modal-paragraph fw-bold"> {{ convert('vehicles.higherExistingOffer.higherOffer') }} {{
      highestOfferAmount | number: '1.0-0' }}</p>
    <p class="modal-paragraph fw-bold"> {{ convert('vehicles.higherExistingOffer.yourOffer') }} {{ offerAmount
      | number: '1.0-0' }}</p>
    <p class="modal-paragraph">{{ convert('vehicles.higherExistingOffer.textWarning') }}</p>

    <div class="mt-3 d-flex flex-column flex-lg-row lg-justify-content-start">
      <button class="btn btn-action btn-primary" type="submit" (click)="continueOffer.emit()" allytmln="modalContinue">
        {{ convert('common.btnContinue') }}
      </button>
      <button class="btn btn-secondary" type="submit" (click)="cancelOffer.emit()" allytmln="modalCancel">
        {{ convert('common.btnCancel') }}
      </button>
      <button class="mt-3 mt-lg-0 btn btn-link" type="button" (click)="backOffer.emit()" allytmln="modalBack">
        {{ convert('common.btnBack') }}
      </button>
    </div>
    <div class="modal-close-container">
      <button id="close_x_button" class="modal__close" [attr.aria-label]="convert('common.modalClose')"
        data-micromodal-close allytmln="modalClose" (click)="cancelOffer.emit()">
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</ng-container>
